import { useMemo } from "react";

import { useTranslation } from "react-i18next";

export function localeFor(lng: string): string {
  return lng.startsWith("es") ? "es-US" : "en-US";
}

export function useLocale(): string {
  const { i18n } = useTranslation();
  return localeFor(i18n.language || "en");
}

export function useMoney(
  options: Omit<Intl.NumberFormatOptions, "style" | "currency"> = {},
) {
  const { i18n } = useTranslation();
  return useMemo(
    () =>
      new Intl.NumberFormat(localeFor(i18n.language || "en"), {
        style: "currency",
        currency: "USD",
        ...options,
      }),
    [i18n.language, options],
  );
}

export function useNumber(options: Intl.NumberFormatOptions = {}) {
  const { i18n } = useTranslation();
  return useMemo(
    () =>
      new Intl.NumberFormat(localeFor(i18n.language || "en"), options),
    [i18n.language, options],
  );
}

export function formatMoney(
  value: number,
  lng: string,
  options: Omit<Intl.NumberFormatOptions, "style" | "currency"> = {},
) {
  return new Intl.NumberFormat(localeFor(lng), {
    style: "currency",
    currency: "USD",
    ...options,
  }).format(value);
}
